import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { isEmbeddedApp } from 'lqx-react/lib';
import { IdleMessageComponent } from 'src/app/components/idle-message/idle-message.component';
import { ActivityMonitoringService, ActivityStatus } from 'src/app/services/activity-monitoring.services';
import { AppConfigService, AuthTimeoutOptions } from 'src/app/services/app-config.service';
import { AuthService } from 'src/app/services/auth.service';
import { RestService } from 'src/app/services/rest.service';
import { UserEntitlementsService } from 'src/app/services/user-entitlements.service';
import { ReactPageComponent } from '../../../../common';
import { DigitizationPageRouter } from './page-router';

@Component({
    selector: 'app-page-ingest',
    template: '<div class="react-page" #container></div>'
})
export class DigitizationRootComponent extends ReactPageComponent {
    private authTimeouts: AuthTimeoutOptions;
    hasIdled = false;
    idleState = 'Not started.';
    status: ActivityStatus;
    popRef: MatDialogRef<IdleMessageComponent>;
    timedOut = false;
    tokenExpires: string;
    lastPing?: Date = null;

    constructor(
        private appConfigService: AppConfigService,
        private idle: Idle,
        private appRef: ChangeDetectorRef,
        private amService: ActivityMonitoringService,
        private authService: AuthService,
        private dialog: MatDialog,
        private keepalive: Keepalive,
        rest: RestService,
        router: Router,
        public zone: NgZone,
        private userEntitlementsService: UserEntitlementsService
    ) {
        super(rest, router, zone, appConfigService);
        this.appConfigService = appConfigService;
        this.authTimeouts = appConfigService.getConfig().msalAuth.timeouts;
        idle.setIdle(this.authTimeouts.idleSecondsBeforeWarningStart);
        idle.setTimeout(this.authTimeouts.warningSecondsBeforeLogout);
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onIdleEnd.subscribe(() => {
            this.hasIdled = false;
            this.idleState = `No longer idle.`;
            this.status = { state: this.idleState, active: this.hasIdled };
            this.popRef.close();
            this.appRef.detectChanges();
        });

        idle.onTimeout.subscribe(() => {
            this.idleState = `Timed out!`;
            this.timedOut = true;
            this.status = { state: this.idleState, active: false };
            this.amService.setStatus(this.status);
            this.authService.msalLogout();
        });

        idle.onIdleStart.subscribe(() => {
            this.popRef = this.dialog.open(IdleMessageComponent);
            this.hasIdled = true;
            this.idleState = `You've gone idle!`;
            this.tokenExpires = localStorage.getItem('expires_at');
            this.status = { state: this.idleState, active: this.hasIdled, expires: this.tokenExpires };
            console.log(this.idleState);
            this.amService.setStatus(this.status);
        });

        idle.onTimeoutWarning.subscribe((countdown: number) => {
            this.idleState = `You will be logged out in ${countdown} seconds`;
            this.status = { state: this.idleState, active: this.hasIdled, expires: this.tokenExpires, countdown };
            this.amService.setStatus(this.status);
        });

        keepalive.onPing.subscribe(() => {
            // this won't be needed once we have the API gateways get the session tokens from the auth service, which itself will
            // ensure the token is refreshed if necessary
            this.authService.ensureLoggedIn();
            this.lastPing = new Date();
        });
        this.start();
    }

    public start(): void {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
        this.status = { state: this.idleState };
        this.amService.setStatus(this.status);
        if (!isEmbeddedApp()) {
            localStorage.setItem('platformCode', 'LQX');
        }
    }

    async reactPageWillMount(): Promise<void> {
        if (this.appConfigService.shouldEnforceUserEntitlements()) {
            console.log('Loading entitlements...');
            await this.userEntitlementsService.ensureEntitlementsAreLoaded();
            console.log('Entitlements were loaded');
        }
    }

    get Component() {
        return DigitizationPageRouter;
    }
}
